import React, { Component } from 'react'

// lib
import { Row } from 'antd'

// redux
import { connect } from 'react-redux'

// subcomponent
import MediaComponent from './media_component'

class ListMedias extends Component {
    render() {
        let { medias } = this.props

        return (
            <Row className="ListMedias">
                {medias
                    ? medias.map((media, index) => {
                          return <MediaComponent media={media} key={index} />
                      })
                    : null}
                {medias.length === 0 && <text>Không có dữ liệu</text>}
            </Row>
        )
    }
}

const mapStateToProps = state => {
    return {
        medias: state.component_select_media.medias,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListMedias)
